import React from 'react';
import { SaveIcon, ZapIcon, FileTextIcon } from 'lucide-react';
export function Features() {
  const features = [{
    tag: 'PRO',
    tagColor: '#F5C842',
    bgColor: '#1A2E1F',
    icon: SaveIcon,
    title: 'Save your rooms. Reuse forever.',
    description: 'A signature style your buyers recognise across every listing.',
    image: 'https://cdn.magicpatterns.com/uploads/cyYDZ3DcEM2w6yxn1w8nkj/0x0ss_(45).png',
    benefits: ['Build a library of custom rooms', 'Consistent brand across all listings', 'Unlimited saves and generations']
  }, {
    tag: 'STUDIO',
    tagColor: '#F5C842',
    bgColor: '#2A1F1A',
    icon: ZapIcon,
    title: '30 listings, one tap.',
    description: 'Apply your whole collection to any room and walk away.',
    image: 'https://cdn.magicpatterns.com/uploads/kcMP8nTCJ5joyzsmgQMzoY/0x0ss_(46).png',
    benefits: ['Batch generate multiple artworks', 'Mix and match rooms × sizes', 'Save hours of manual work']
  }, {
    tag: 'ETSY-READY',
    tagColor: '#3B9EFF',
    bgColor: '#1A1A2E',
    icon: FileTextIcon,
    title: 'Title and description, written.',
    description: 'AI drafts your listing copy. Copy, paste, publish.',
    image: 'https://cdn.magicpatterns.com/uploads/m9ecTrprmXvzXnbhpMyQ4X/0x0ss_(47).png',
    benefits: ['SEO-optimized Etsy titles', 'Compelling product descriptions', 'One-click copy to clipboard']
  }];
  return <section className="w-full bg-[#0A0A0F] py-24 lg:py-32" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6" data-id="element-34">
        <div className="text-center mb-20" data-id="element-35">
          <span className="text-sm font-bold text-[#3B9EFF] tracking-widest uppercase" data-id="element-36">
            Features
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mt-4 leading-tight tracking-tight" data-id="element-37">
            Built for serious sellers
          </h2>
        </div>

        <div className="space-y-24" data-id="element-38">
          {features.map((feature, index) => <div key={index} className={`grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`} data-id="element-39">
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-40">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full mb-6" style={{
              backgroundColor: `${feature.tagColor}20`,
              border: `1px solid ${feature.tagColor}40`
            }} data-id="element-41">
                  <feature.icon className="w-4 h-4" style={{
                color: feature.tagColor
              }} data-id="element-42" />
                  <span className="text-xs font-bold tracking-widest uppercase" style={{
                color: feature.tagColor
              }} data-id="element-43">
                    {feature.tag}
                  </span>
                </div>

                <h3 className="text-4xl sm:text-5xl font-black text-white mb-4 leading-tight tracking-tight" data-id="element-44">
                  {feature.title}
                </h3>

                <p className="text-xl text-gray-400 mb-8 leading-relaxed" data-id="element-45">
                  {feature.description}
                </p>

                <ul className="space-y-4" data-id="element-46">
                  {feature.benefits.map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-47">
                      <div className="w-6 h-6 rounded-full bg-[#3B9EFF]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-48">
                        <div className="w-2 h-2 rounded-full bg-[#3B9EFF]" data-id="element-49"></div>
                      </div>
                      <span className="text-gray-300" data-id="element-50">{benefit}</span>
                    </li>)}
                </ul>
              </div>

              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-51">
                <div className="relative rounded-2xl overflow-hidden" style={{
              backgroundColor: feature.bgColor
            }} data-id="element-52">
                  <div className="aspect-[9/16] flex items-center justify-center p-8" data-id="element-53">
                    <img src={feature.image} alt={feature.title} className="w-full max-w-sm drop-shadow-2xl" data-id="element-54" />
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}